/* unplugin-vue-components disabled */import { render } from "./Recorder-Player.vue?vue&type=template&id=376ef93e&scoped=true"
import script from "./Recorder-Player.vue?vue&type=script&lang=js"
export * from "./Recorder-Player.vue?vue&type=script&lang=js"

import "./Recorder-Player.vue?vue&type=style&index=0&id=376ef93e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376ef93e"]])

export default __exports__